<!-- 
  This component is for handling OLD client landing page,
  which will be redirected to the new landing page  
-->

<template>
  <div class="text-center">
    <div class="bg-gray-200 p-8 text-sm text-gray-900 inline-block mt-20 rounded">
      <span class="blink">Validating your access...</span>
    </div>
  </div>
</template>

<script>
  export default {
    created() {

      // handle the landing for the client
      if(this.$route.params.key != null) {
        this.apiPost({
          key : this.$route.params.key
        }, 'client/validate-old-key', (data) => {
          if(data.clientId) {
            this.$router.push({
              name  : 'client-landing',
              params: {
                clientId: data.clientId,
                key     : this.$route.params.key
              }
            })
          }
        })
      }
    }
  }
</script>